<template>
  <header :class="{ 'app-header': true, 'app-header_primary': primary, 'app-header_full': full }">
    <div class="app-header__content">
      <div class="app-header__left">
        <app-brand :primary="!primary"></app-brand>
        <h3 class="app-header__title" v-if="title">{{ title }}</h3>
        <slot name="left"></slot>
      </div>
      <div class="app-header__right">
        <slot name="right"></slot>
      </div>
    </div>
  </header>
</template>

<script>
import AppBrand from '@/components/AppBrand'

export default {
  name: 'AppHeader',
  components: {
    AppBrand
  },
  props: {
    primary: {
      type: Boolean,
      default: false
    },
    full: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
$name: '.app-header';

#{$name} {
  height: $nav-height;
  background-color: #fff;

  &_primary {
    background-color: $primary-color;

    #{$name}__left,
    #{$name}__right {
      color: #fff;
    }
  }

  &_full {
    #{$name}__content {
      width: 100%;
    }
  }

  &__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: $page-width;
    height: 100%;
    padding: 0 15px;
    margin: 0 auto;
  }

  &__left {
    display: flex;
    align-items: center;
  }

  &__title {
    padding: 0 30px;
    margin: 0 0 0 30px;
    border-left: 1px solid #ccc;
    font-size: 16px;
    font-weight: 400;
  }
}
</style>
